import type { App } from 'vue';

import { RpcApiService } from '@/api/client/services/SSEApiService';
import { createRpcClient } from '@/shared/api/rpc/client';
import { useNotificationStore } from '@/shared/model';

export function provideRpcClient(app: App) {
  const { notifyError } = useNotificationStore();

  const rpcClient = createRpcClient({
    apiService: new RpcApiService(),
    notifyError,
  });
  app.provide('rpcClient', rpcClient);
}
